import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges, ViewEncapsulation} from "@angular/core";
import {Trial} from "../../model/trial";


@Component({
  selector: 'gen-text-viewer',
  templateUrl: './text-viewer.component.html',
  styleUrls: ['./text-viewer.component.scss', 'entity-colors.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class TextViewerComponent implements OnChanges {

  @Input() trial: Trial;

  brief_title: string;
  official_title: string;
  brief_summary: string;
  detailed_description: string;
  arm_groups: string;
  eligibility: string;

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.trial && this.trial) {
      let trial: Trial = this.trial;
      let cs = trial.clinical_study;
      let mm = trial.mentions;
      this.brief_title = this.getAnnotatedText(this.getText(cs.brief_title), mm, 'brief_title');
      this.official_title = this.getAnnotatedText(this.getText(cs.official_title), mm, 'official_title');
      this.brief_summary = this.getAnnotatedText(this.getText(cs.brief_summary), mm, 'brief_summary');
      this.detailed_description = this.getAnnotatedText(this.getText(cs.detailed_description), mm, 'detailed_description');

      let arms = cs.arm_group ? Array.isArray(cs.arm_group) ? cs.arm_group : [cs.arm_group] : [];
      let text = undefined;

      for (let arm of arms) {
        let label = this.getText(arm.arm_group_label);
        let type = this.getText(arm.arm_group_type);
        let description = this.getText(arm.description);
        let body = (type ? type + ':' : '') + (label ? label : '') + '<br>' + (description ? description + '<br>' : '');

        text = (text ? text + '<br>' : "") + body;
      }
      this.arm_groups = text;

      this.eligibility = this.getAnnotatedText(this.getText(cs.eligibility.criteria), mm, 'eligibility');
    }
  }

  private getText(obj: any): string {
    if (!obj) return null;
    if (obj['textblock']) obj = obj.textblock;
    return obj['_text'];
  }

  private getAnnotatedText(original: string, mentions: any[], key: string): string {
    if (!original) return null;

    original = original.replace(/[\r]/g, '');
    original = original.replace(/</g, '\x01');
    original = original.replace(/&/g, '\x02');

    let mm = mentions.filter(mention => mention.field_path.includes(key));

    let spans = [];

    for (let i = 0; i < mm.length; i++) {
      let mention = mm[i];
      let type = mention.mention_type.toLowerCase();

      // Ignore numbers for now. They mess-up the item detection below!
      if (type == 'drug'
        || type == 'hugene'
        || type == 'l10n_def'
        || type == 'l10n_ref'
        || type == 'resposres'
        || type == 'disease'
      ) {

        // We get the spans as a 1-dim array of [start1, end1, start2, end2, ...]
        for (let j = 0; j < mention.mention_spans.length; j += 2) {
          let x = mention.mention_spans[j];
          let y = mention.mention_spans[j + 1];
          let gloss = mention.mention_gloss;

          if (x < y && y < original.length) {
            spans.push({type: type, start: x, end: y, gloss: gloss})
          }
        }
      }
    }


    // Sort longest first
    spans.sort((a, b) => (b.end - b.start) - (a.end - a.start));
    let spans2 = [];
    for (let i = 0; i < spans.length; i++) {
      if (!this.overlaps(spans[i], spans2)) {
        spans2.push(spans[i]);
      }
      else {
        let x = 1;
      }
    }
    spans = spans2;

    // Reverse sort
    spans.sort((a, b) => b.start - a.start);

    let result = original;
    for (let i = 0; i < spans.length; i++) {
      result = result.substring(0, spans[i].start)
        + '<span class="entity mytooltip ' + spans[i].type + '">'
        + result.substring(spans[i].start, spans[i].end)
        + '<span class="mytooltiptext">' + spans[i].type + ': ' + spans[i].gloss + '</span>'
        + '</span>'
        + result.substring(spans[i].end, result.length);
    }

    result = result.replace(/\x01/g, '&lt;');
    result = result.replace(/\x02/g, '&amp;');

    // Patch to add some <br>s to the text where newlines are expected
    result = result.replace(/\n(\s*(?:\d+[.]|[-])\s+)/g, '<br>\n$1');

    return result;
  }

  private overlaps(span, spans): boolean {
    for (let i = 0; i < spans.length; i++) {
      if (span.start < spans[i].end && span.end > spans[i].start) {
        return true;
      }
    }
    return false;
  }
}
